import { render } from "./AcceptancePaymentSelectVendorBankDialog.vue?vue&type=template&id=f887225e&scoped=true"
import script from "./AcceptancePaymentSelectVendorBankDialog.vue?vue&type=script&lang=ts"
export * from "./AcceptancePaymentSelectVendorBankDialog.vue?vue&type=script&lang=ts"

import "./AcceptancePaymentSelectVendorBankDialog.vue?vue&type=style&index=0&id=f887225e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f887225e"

export default script